import {Deal} from "./../../models/Deal";
import {Step} from "./../../models/Step";

let parseData = (data)=>data.map(item=>new Deal(item));

let toDealList = (data)=>{
    if(Array.isArray(data))
        data = parseData(data);
    else
        data.data = parseData(data.data);
    return data;
}

let dealsApi = {
    async get(type, filters, page=1, token, companyId,
              fields=['deals.id','deals.client_id','deals.user_id', 'deals.step_id', 'deals.type', 'deals.status', 'deals.visible_number', 'deals.created_at', 'deals.external_ref', 'deals.value', 'deals.final_value', 'deals.closing_date', 'deals.sale_potential'],
              relationships= ['client:id,name', 'step:id,title,stepable_id,stepable_type', 'step.stepable:id,title,stepable_id,stepable_type', 'step.stepable.stepable:id,title', 'user:id,name,lastname', 'collaborators:id,name,lastname']){
        let response = await window.axios.get('/api/deals'+(type?"/"+type:""), {
            params:{
                api_token:token,
                company_logged:companyId,
                page: page,
                fields: fields,
                relationships: relationships,
                ...filters
            }
        });
        return toDealList(response.data);
    },
    async find(id, token, companyId,
               fields=['deals.id', 'deals.step_id', 'deals.client_id', 'deals.user_id', 'deals.type', 'deals.status', 'deals.visible_number', 'deals.created_at', 'deals.external_ref', 'deals.value', 'deals.final_value', 'deals.sale_potential'],
               relationships= ['client:id,name', 'step:id,title,stepable_id,stepable_type', 'user:id,name,lastname', 'collaborators:id,name,lastname']){
        let response = await window.axios.get('/api/deals/'+id, {
            params:{
                api_token:token,
                company_logged:companyId,
                fields: fields,
                relationships: relationships,
            }
        });
        return new Deal(response.data);
    },
    async create(deal, token, companyId){
        let response = await window.axios.post('/api/deals', deal, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new Deal(response.data);
    },
    async edit(deal, token, companyId){
        let response = await window.axios.put('/api/deals/'+deal.id, deal, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new Deal(response.data);
    },
    async delete(deal, token, companyId){
        let response = await window.axios.delete('/api/deals/'+deal.id, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return !!response.data.success;
    },
    async changeParentStep(deal, stepTitle, token, companyId){
        let response = await window.axios.put('/api/deals/'+deal.id+'/change-parent-step', null,  {
            params:{
                api_token:token,
                company_logged:companyId,
                step_title: stepTitle
            }
        });
        return response.data;
    },
    async changePipe(deal, pipeId, token, companyId){
        let response = await window.axios.put('/api/deals/'+deal.id+'/change-pipe', null,  {
            params:{
                api_token:token,
                company_logged:companyId,
                pipe_id: pipeId
            }
        });
        return new Step(response.data);
    },
    async toContact(filters, page=1, token, companyId){
        let response = await window.axios.get('/api/deals/toContact', {
            params:{
                api_token:token,
                company_logged:companyId,
                page: page,
                ...filters
            }
        });
        return toDealList(response.data);
    },
    async clearHotList(filters, token, companyId){
        let response = await window.axios.post('/api/deals/clearHotList',{
            api_token:token,
            company_logged:companyId,
            ...filters
        })
        return 'cleared';
    },
    async clearDeals(filters, token, companyId){
        let response = await window.axios.post('/api/deals/clearDeals', {
            api_token:token,
            company_logged:companyId,
            ...filters
        })
        return response;
    }
}

export default dealsApi